import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayout, AuthGuard, FirstLoginGuard } from '@authentication';
import { TranslateModule } from '@ngx-translate/core';
import {
  MainLayoutComponentModule,
  MainLayoutComponent,
} from '@shared/main-layout';

import {
  SUMMARY_PAGE_TITLE,
  TRANSACTIONS_PAGE_TITLE,
  USERS_PAGE_TITLE,
  METRICS_PAGE_TITLE,
  NEW_LINK_PAGE_TITLE,
  UPDATE_PAYMENT_METHOD_PAGE_TITLE,
} from '@shared/utils/i18n/constants';
import { PermissionGuardService } from './shared/interceptors/permission-guard.service';
import { PipesModule } from './pipes/pipes.module';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'auth' },
  {
    path: 'auth',
    component: AuthLayout,
    loadChildren: () =>
      import('@authentication').then((m) => m.AuthenticationModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard, FirstLoginGuard],
    data: { title: SUMMARY_PAGE_TITLE, subtitle: 'Dashboard', icon: 'home_2' },
    component: MainLayoutComponent,
    loadChildren: () => import('@dashboard').then((m) => m.DashboardModule),
  },
  {
    path: 'transactions',
    canActivate: [AuthGuard],
    data: {
      title: TRANSACTIONS_PAGE_TITLE,
      subtitle: 'Transacciones',
      icon: '',
    },
    component: MainLayoutComponent,
    loadChildren: () =>
      import('@transactions').then((m) => m.TransactionsModule),
    canActivateChild: [PermissionGuardService],
  },
  {
    path: 'createTransaction',
    canActivate: [AuthGuard],
    data: {
      title: NEW_LINK_PAGE_TITLE,
      subtitle: 'Link de pago',
      icon: '',
    },
    component: MainLayoutComponent,
    loadChildren: () => import('@new-link').then((m) => m.NewLinkModule),
    canActivateChild: [PermissionGuardService],
  },
  {
    path: 'users',
    canActivate: [AuthGuard],
    data: { title: USERS_PAGE_TITLE, subtitle: 'Usuarios', icon: '' },
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./users/users.module').then((m) => m.UsersModule),
    canActivateChild: [PermissionGuardService],
  },
  {
    path: 'metrics-elektra',
    canActivate: [AuthGuard],
    data: {
      title: TRANSACTIONS_PAGE_TITLE,
      subtitle: 'Métricas de recordatorios de pago',
      icon: '',
    },
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./metrics-elektra/metrics-elektra.module').then(
        (m) => m.MetricsElektraModule,
      ),
  },
  {
    path: 'metrics',
    canActivate: [AuthGuard],
    data: {
      title: METRICS_PAGE_TITLE,
      subtitle: 'Métricas',
      icon: '',
    },
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./admin/metrics/metrics.module').then((m) => m.MetricsModule),
  },
  {
    path: 'account',
    canActivate: [AuthGuard],
    data: {
      title: TRANSACTIONS_PAGE_TITLE,
      subtitle: 'Perfil',
      icon: '',
    },
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./my-profile/my-profile.module').then((m) => m.MyProfileModule),
  },
  {
    path: 'blocked-users',
    canActivate: [AuthGuard],
    data: {
      title: TRANSACTIONS_PAGE_TITLE,
      subtitle: 'Usuarios Bloqueados',
      icon: '',
    },
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./blocked-users/blocked-users.module').then(
        (m) => m.BlockedUsersModule,
      ),
  },
  {
    path: 'payoutCards',
    canActivate: [AuthGuard],
    data: {
      title: UPDATE_PAYMENT_METHOD_PAGE_TITLE,
      subtitle: 'Push Payments',
      icon: 'convertCard',
    },
    component: MainLayoutComponent,
    loadChildren: () =>
      import('@update-payment-method').then((c) => [
        {
          path: '',
          component: c.UpdatePaymentMethodComponent,
        },
      ]),
  },
  {
    path: 'error',
    component: MainLayoutComponent,
    loadChildren: () => import('@error').then((m) => m.ErrorModule),
  },
  { path: '**', pathMatch: 'full', redirectTo: 'error/404' },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
    }),
    MainLayoutComponentModule,
    TranslateModule,
    PipesModule,
  ],
  exports: [RouterModule, MainLayoutComponentModule],
})
export class AppRoutingModule {}
